import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class HttpCommonService {

  // httpOptions = {
  //   headers: new HttpHeaders(
  //     {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer ' + this.tokenService.getToken(),
  //     },
  //     )
  // };

  getHttpOptions(): any {
    return {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.tokenService.getToken()
        }),
      withCredentials: true
    };
  }

  constructor(
    private tokenService: TokenService
  ){}

  // getHeaders(){
  //   const _headers = new HttpHeaders();
  //   const headers = _headers.append('Authorization', `Bearer ${this.tokenService.getToken()}`);
  //   return headers;
  // }


  toHttpParams(obj) {
    let httpParams = new HttpParams();
    Object.keys(obj).forEach(key => {
      httpParams.append(key, obj[key]);
    });
    return httpParams;
  }

  basicErrorHandler(error: HttpErrorResponse) {
    let errorMessage = '';
    console.log(error);
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = 'An error occurred:' + error.message;
      console.error(errorMessage);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = error.error;
      console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(errorMessage);
  }

     /**
  * Handle Http operation that failed.
  * Let the app continue.
  * @param operation - name of the operation that failed
  * @param result - optional value to return as the observable result
  */
  handleError<T> (operation = 'operation', result?: T, showDialog = true, customErrorMsg = '') {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(`${message}`);
  }

}
